import axios from "axios";

const API_URL = "https://apireferidos-service-26551171030.us-east1.run.app/api";

// instancia de axios para las solicitudes que no requieren autenticación
const referralAxiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const SendEmailToChangeReferral = async (data) => {
  try {
    const axiosInstance = (await import("./auth")).default;
    const response = await axiosInstance.post("/referral/request-referee", {
      base_url: `${window.location.origin}/accept-invitation`,
      referee_email: data.email,
      code: data.referralCode,
    });
    return response.data;
  } catch (error) {
    if (!error.response) {
      throw error;
    }
    const errorData =
      error.response.data && typeof error.response.data === "object"
        ? error.response.data
        : { message: error.response.data };

    errorData.httpStatus = error.response.status;

    throw errorData;
  }
};

export const acceptReferralChange = async (token, referralCode) => {
  try {
    const response = await referralAxiosInstance.patch(
      "/referral/change-referrer",
      {
        token: token,
        referral_code: referralCode,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error en acceptReferralChange:", error);
    throw error.response ? error.response.data : error;
  }
};
